import i18n from 'i18n';
import { COMMON_GRID_COLUMN_FIELD_NAMES } from 'shared/commonGrid/grid-enums';
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { DialedDigitExtractionServer } from 'data/dialedDigitExtractionServer/dialedDigitExtractionServer.types';
import { stateValueFormatter } from 'utils/valueFormatters';
import DialedDigitExtractionServerCellRenderer from './components/DialedDigitExtractionServerCellRenderer';
import distributorValueGetter from './utils/dialedDigitExtractionServerValueGetter';

export enum DistributorMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const newDialedDigitExtractionServer: DialedDigitExtractionServer = {
  id: '',
  msid: '',
  ipaddr: '',
  port: '',
  ownnetid: '',
  asstate: '',
  reqstate: 'ACTIVE',
};

export const distributorColumnDefs: ColDef[] = [

  {
    headerName: i18n.t('dialedDigitExtractionServer.grid.mediaServerId'),
    field: 'msid',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'msid',
    flex: 1,
    minWidth: 198,
  },
  {
    headerName: i18n.t('dialedDigitExtractionServer.grid.iPAddress'),
    field: 'ipaddr',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'ipaddr',
    flex: 1,
    minWidth: 198,
  },
  {
    headerName: i18n.t('dialedDigitExtractionServer.grid.port'),
    field: 'port',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'port',
    flex: 1,
    minWidth: 198,
  },
  {
    headerName: i18n.t('dialedDigitExtractionServer.grid.network'),
    field: 'ownnetid',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'ownnetid',
    flex: 1,
    minWidth: 198,
  },
  {
    headerName: i18n.t('dialedDigitExtractionServer.grid.configuredState'),
    field: 'reqstate',
    sortable: true,
    filter: 'agSetColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    minWidth: 130,
    valueFormatter: stateValueFormatter,
  },
  {
    headerName: i18n.t('dialedDigitExtractionServer.grid.currentStatus'), // 'Current Status',
    field: 'asstate',
    sortable: true,
    filter: 'agSetColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'asstate',
    flex: 1,
    minWidth: 140,
    cellRendererFramework: DialedDigitExtractionServerCellRenderer,
    valueGetter: distributorValueGetter,
  },
];
